module.exports = __webpack_public_path__ + "static/media/residential-building.9170cf5e.webp";